import Common from '../../../Common';

const User = class extends Common {
	async delete(companyId: id, departmentId: id, userId: id) {
		return this.doDelete(`/company/${companyId}/department/${departmentId}/user/${userId}`)
	}

	async update(companyId: id, departmentId: id, userId: id) {
		return this.patch(`/company/${companyId}/department/${departmentId}/user/${userId}`)
	}
}

export default User
